/**
 * Giorni trial rimanenti (allineato a gym_billing_trial_days_left PHP).
 * Conteggio per giorno di calendario, inclusivo dell'ultimo giorno.
 */
export function gymBillingTrialDaysLeft(trialEndsAt) {
    if (!trialEndsAt) {
        return { daysLeft: null, trialExpired: false };
    }

    const parseDay = (iso) => {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) {
            return null;
        }
        d.setHours(0, 0, 0, 0);
        return d;
    };

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDay = parseDay(trialEndsAt);
    if (!endDay) {
        return { daysLeft: null, trialExpired: false };
    }

    if (today > endDay) {
        return { daysLeft: 0, trialExpired: true };
    }

    const msPerDay = 86400000;
    const daysLeft = Math.round((endDay - today) / msPerDay) + 1;

    return { daysLeft, trialExpired: false };
}
